import { useEffect, useState } from 'react';

// Hodiny dne, kdy se v 'auto' režimu používá denní mód [DEN_OD, DEN_DO).
// Mimo tento interval (večer/noc/brzké ráno) je noční mód.
const DEN_OD = 6;   // 6:00
const DEN_DO = 20;  // 20:00

export type NocniRezim = 'auto' | 'light' | 'dark';

const isNightNow = (): boolean => {
    const h = new Date().getHours();
    return h < DEN_OD || h >= DEN_DO;
};

/**
 * Resolvuje aktuální noční mód dle konfigurace:
 *   - 'dark' → vždy noční (true)
 *   - 'light' → vždy denní (false)
 *   - 'auto' → podle aktuální hodiny ({@link DEN_OD}–{@link DEN_DO} = denní)
 *
 * V 'auto' módu se interně přepočítává každou minutu (kvůli přechodu denní↔noční přes hranici).
 */
export const useNocniRezim = (config: NocniRezim | undefined): boolean => {
    const [autoIsDark, setAutoIsDark] = useState<boolean>(() => isNightNow());

    useEffect(() => {
        if (config !== 'auto') return;
        const update = () => setAutoIsDark(isNightNow());
        update();
        const interval = setInterval(update, 60_000);
        return () => clearInterval(interval);
    }, [config]);

    if (config === 'dark') return true;
    if (config === 'light') return false;
    // 'auto' nebo undefined → reagovat na čas
    return autoIsDark;
};
